/** Maximum content width of the dashboard, matching the mockup. */
export const CONTAINER_MAX_WIDTH = '1160px'

/** Height of the sticky app bar in pixels. */
export const NAV_BAR_HEIGHT = 64

/**
 * Storage quota per user in bytes (100 GB). Mirrors the editor's upload limit
 * (`UPLOAD_LIMIT_BYTE`) so the storage gauge shows the same total the editor enforces.
 */
export const STORAGE_LIMIT_BYTE = 1024 ** 3 * 100

/** The Hatsuly Help Center (user manual) — same target as the legacy dashboard's footer link. */
export const HELP_CENTER_URL = 'https://datalabs-jp.notion.site/Hatsuly-Help-Center-66c3998d14fa4255b7dce709249315f6'

/**
 * General contact form (HubSpot) — the legacy dashboard's お問い合わせ target, also used to
 * request a point-cloud alignment (位置合わせ) since alignment is handled as a service request.
 */
export const GENERAL_CONTACT_URL = 'https://share.hsforms.com/11_hEhYjCR0CBEe1gX9adVQddydr'
